const doesAffiliateIdExist = (affiliateId: string) => affiliateId && affiliateId !== 'NULL' && affiliateId !== 'none' && affiliateId !== 'undefined';
export const isInfluencers = (affiliateId: string, medium: string) => doesAffiliateIdExist(affiliateId) || medium === 'affiliate';
export const isJunGroup = (source: string) => source === 'jun' || source === 'jungroup';
export const isPaidTraffic = (medium: string) => medium === 'cpc' || medium === 'paid';
